var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"container-left1"},[_c('LeftLevelNavigation',{ref:"leftLevelNavigation"})],1),_c('div',{staticClass:"container-main"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }